import { FIELD_CLIENT_ID_PROJECT } from 'Pages/Projects/ProjectModal'
import { BUDGET_AMOUNT_TYPES } from './BudgetSettings'

export const buildSettingsDefaults = (project) => ({
  [FIELD_CLIENT_ID_PROJECT]: project.client.id,
  name: project.name || '',
  code: project.code || '',
  note: project.note || '',
  budget_method: project.budget?.method || 'No budget',
  budget_type: project.budget?.type || 'Fixed fee',
  budget_amount: project.budget?.amount ?? 0,
  budget_frequency: project.budget?.frequency || 'week',
  billing_method: project.billing?.method || 'Free of charge'
})

export const buildBudgetPayload = (v) => {
  const isNoBudget = v.budget_method === 'No budget'
  const keepsAmount = !isNoBudget && BUDGET_AMOUNT_TYPES.includes(v.budget_type)

  return {
    method: v.budget_method,
    ...(isNoBudget ? {} : { type: v.budget_type }),
    ...(v.budget_method === 'Recurrent' ? { frequency: v.budget_frequency } : {}),
    ...(keepsAmount ? { amount: Number(v.budget_amount) || 0 } : {})
  }
}

export const budgetHasChanged = (v, project) => {
  const desired = buildBudgetPayload(v)
  const current = project.budget

  if (!current) return desired.method !== 'No budget'

  return (
    current.method !== desired.method ||
    (current.type || null) !== (desired.type ?? null) ||
    (current.frequency || null) !== (desired.frequency ?? null) ||
    Number(current.amount || 0) !== Number(desired.amount ?? 0)
  )
}

export const billingHasChanged = (v, project) => {
  if (!project.billing) return v.billing_method !== 'Free of charge'
  return project.billing.method !== v.billing_method
}

export const summarizeChanges = (v, project) => {
  const rows = [
    { label: 'Name', value: v.name },
    { label: 'Code', value: v.code }
  ]

  if (budgetHasChanged(v, project)) {
    const b = buildBudgetPayload(v)
    let budgetValue = b.method
    if (b.type) budgetValue += ` · ${b.type}`
    if (b.amount !== undefined) budgetValue += ` · ${v.budget_type === 'Fixed fee' ? '$' : ''}${b.amount}${v.budget_type === 'Fixed hours' ? ' hours' : ''}`
    if (b.frequency) budgetValue += ` · each ${b.frequency}`
    rows.push({ label: 'Budget', value: budgetValue })
  }

  if (billingHasChanged(v, project)) {
    rows.push({ label: 'Billing', value: v.billing_method })
  }

  return rows
}
